import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Link } from "react-router-dom";
import { Check, ArrowRight, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const STEP_ROUTES = { profile: "/settings", party: "/clients", invoice: "/sales" };
const STEP_CTA = { profile: "Buka Branding", party: "Tambah Klien", invoice: "Buat Invoice" };

export default function OnboardingWizard() {
  const [state, setState] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    api.get("/onboarding/status").then(r => setState(r.data)).catch(() => setState(null));
  }, []);

  const skipForever = async () => {
    await api.post("/onboarding/complete");
    setDismissed(true);
  };

  if (!state || state.completed || dismissed) return null;

  const doneCount = state.steps.filter(s => s.done).length;
  const progress = Math.round((doneCount / state.steps.length) * 100);

  return (
    <div data-testid="onboarding-wizard" className="card-grid p-6 border-l-4 border-l-[#D99C3B] bg-gradient-to-br from-white to-forest-50">
      <div className="flex items-start justify-between gap-4">
        <div>
          <div className="label-tag mb-1">Mulai Cepat</div>
          <h3 className="font-display text-2xl tracking-tight">Selamat datang! Mari selesaikan 3 langkah singkat</h3>
          <p className="text-sm text-forest-400 mt-1">Setelah ini Anda bisa langsung tagih dan pantau bisnis.</p>
        </div>
        <button onClick={skipForever} data-testid="btn-skip-onboarding" className="text-forest-400 hover:text-[#151A18] p-1" title="Sembunyikan selamanya"><X size={16}/></button>
      </div>

      <div className="mt-4 flex items-center gap-3">
        <div className="flex-1 h-1.5 bg-forest-100 rounded-full overflow-hidden">
          <div className="h-full bg-[#D99C3B] transition-all duration-500" style={{ width: `${progress}%` }}/>
        </div>
        <div className="text-xs text-forest-400 num min-w-[3rem] text-right">{doneCount} / {state.steps.length}</div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mt-5">
        {state.steps.map((s, i) => (
          <div key={s.key} data-testid={`step-${s.key}`} className={`p-4 rounded-sm border-2 transition-colors ${s.done ? "border-[#4A6B53] bg-[#4A6B53]/5" : "border-forest-100 bg-white"}`}>
            <div className="flex items-center gap-2 mb-2">
              <div className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold ${s.done ? "bg-[#4A6B53] text-white" : "bg-forest-100 text-forest-400"}`}>
                {s.done ? <Check size={14}/> : i+1}
              </div>
              <div className="text-xs uppercase tracking-widest text-forest-400">Langkah {i+1}</div>
            </div>
            <div className="text-sm font-medium mb-3 min-h-[2.5rem]">{s.label}</div>
            {!s.done ? (
              <Link to={STEP_ROUTES[s.key]}>
                <Button size="sm" data-testid={`btn-step-${s.key}`} className="rounded-sm bg-[#2D4739] hover:bg-[#22362B] w-full gap-1">
                  {STEP_CTA[s.key]} <ArrowRight size={14}/>
                </Button>
              </Link>
            ) : (
              <div className="text-xs text-[#4A6B53] font-medium">Selesai ✓</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
